import { FormikValues, useFormikContext } from "formik";
import { get } from "lodash";
import { ComponentPropsWithoutRef } from "react";
import PillarFormInputWrapper, {
  PillarFormInputWrapperProps,
} from "./PillarFormInputWrapper";

export type PillarFormPasswordInputProps = PillarFormInputWrapperProps &
  Omit<ComponentPropsWithoutRef<"input">, "id" | "name" | "value" | "type">;

//TODO: We should rename "additionalClasses" to "containerClasses" or something more descriptive.
const PillarFormPasswordInput = ({
  name,
  label,
  labelClassName,
  additionalClasses,
  className,
  testid,
  onChange,
  ...props
}: PillarFormPasswordInputProps) => {
  const { values, setFieldValue } = useFormikContext<FormikValues>();
  const value = get(values, name);
  return (
    <PillarFormInputWrapper
      name={name}
      labelClassName={labelClassName}
      label={label}
      additionalClasses={`${additionalClasses ?? ""}`}
    >
      <input
        type="password"
        className={`${className ? className : ""}`}
        value={value}
        name={name}
        id={name}
        data-testid={testid}
        onChange={(e) => {
          setFieldValue(name, e.target.value);
          if (onChange) {
            onChange(e);
          }
        }}
        {...props}
      />
    </PillarFormInputWrapper>
  );
};

export default PillarFormPasswordInput;
